/* src/app/components/LogOutButton/index.js */

import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { Button } from '@material-ui/core';
import { ExitToApp } from '@material-ui/icons';
import styles from './styles';
import { loadTexts } from '../../../config/texts';
const TEXT_KEY = 'components';

const LogOutButton = ({ classes, onLogOut, locale }) => {
  const texts = loadTexts(TEXT_KEY, locale);
  return (
    <Button
      variant="outlined"
      className={classes.logOutButton}
      color="inherit"
      size="small"
      onClick={onLogOut}
    >
      <ExitToApp className={classes.icon} />
      {texts.button_text.logout}
    </Button>
  );
}

LogOutButton.propTypes = {
  classes: PropTypes.object.isRequired,
  onLogOut: PropTypes.func,
};

LogOutButton.defaultProps = {
  onLogOut: () => {},
};


const mapStateToProps = state => ({
  locale: state.appState.locale,
});

export default compose(
  withStyles(styles, { name: 'LogOutButton' }),
  connect(mapStateToProps, {})
)(LogOutButton);



// WEBPACK FOOTER //
// ./src/app/components/LogOutButton/index.js